// extracted by mini-css-extract-plugin
export default {"overlay":"NavigationMenu_overlay__eU9th","menu":"NavigationMenu_menu__fmL1k","sectionHeader":"NavigationMenu_sectionHeader__lOWw1"};